import gql from 'graphql-tag';

const getBynderAssetDownloadUrl = gql`
  query GetBynderAssetDownloadUrl($bynderAssetId: ID!, $organisationId: ID!) {
    getBynderAssetDownloadUrl(bynderAssetId: $bynderAssetId, organisationId: $organisationId)
  }
`;

export default (() => ({
  query: getBynderAssetDownloadUrl,
  module: 'stock-assets',
  ignoreCache: true,
  buildVariables: ({
    bynderAssetId,
    organisationId
  }) => ({ bynderAssetId, organisationId })
}));